export class Config {
  apiUrl: string;
}
